import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const minimumHorizontalStressPressureMap = new Map();

minimumHorizontalStressPressureMap.set(KnowEdmTableData.Tvd, {
  key: KnowEdmTableData.Tvd,
  label: RecognisedHeaderLabels.DepthTVD,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
});

minimumHorizontalStressPressureMap.set(KnowEdmTableData.MinimumHorizontalStressPressureGradient, {
  key: KnowEdmTableData.MinimumHorizontalStressPressureGradient,
  label: RecognisedHeaderLabels.MinimumHorizontalStressPressureGradient,
  unit: defaultUnits.get(QuantitiesTypes.Density),
  quantity: QuantitiesTypes.Density,
});

minimumHorizontalStressPressureMap.set(KnowEdmTableData.MinimumHorizontalStressPressure, {
  key: KnowEdmTableData.MinimumHorizontalStressPressure,
  label: RecognisedHeaderLabels.MinimumHorizontalStressPressure,
  unit: defaultUnits.get(QuantitiesTypes.PressureСhange),
  quantity: QuantitiesTypes.PressureСhange,
});

export {
  minimumHorizontalStressPressureMap,
};
